import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';
import { Layout, PageHeader, Table, Divider, Spin } from 'antd';

import TradeResult from './TradeResult';

import emitter from '../Evt.js';

const { Content } = Layout;

var moment_timezone = require('moment-timezone');

var languageMessages = window.appLocale.messages;

class RealTimeGeneralStrategyPage extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.user = {};
        this.state = {

            dataSource: [],

            rowId: -1,
            type: 0,

            strategyName: '',

            statisticsResult: [],

            spinLoadding: true

        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
    }

    init = () => {
        var { type } = this.state;

        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_general_strategy_result", payload: { t: type, u: userId } });
    }

    componentWillReceiveProps(props) {
        var { status, items, tradeDetails } = props;

        switch (status) {
            case 'get_general_strategy_result_success':

                var rowId = -1;
                var strategyName = '';
                var dataSource = [];
                if (items.length > 0) {
                    for (var item in items) {
                        if (rowId === -1) {
                            rowId = items[item].strategyId;
                            strategyName = items[item].strategyName;
                        }
                        var sequence = parseInt(item) + 1;

                        dataSource.push({
                            key: items[item].strategyId,
                            sequence: sequence,
                            tradingStraregy: items[item].strategyName,
                            capital: items[item].capital

                        });
                    }
                }

                var statisticsResult = tradeDetails;

                this.setState({ spinLoadding: false, dataSource, statisticsResult, rowId, strategyName });
                break;
            case 'get_general_strategy_result_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_general_strategy_result_search_success':

                var statisticsResult = tradeDetails;

                this.setState({ spinLoadding: false, statisticsResult });
                break;
            case 'get_general_strategy_result_search_fail':
                this.setState({ spinLoadding: false });
                break;
            default:
                break;
        }
    }

    OnSelectShowChart = (record) => {
        return {
            onClick: () => {
                const { dataSource, type } = this.state;

                var tmpData = dataSource.filter(function (e) { return e.key === record.key; });
                if (tmpData.length > 0) {
                    this.setState({ rowId: record.key, strategyName: record.tradingStraregy, spinLoadding: true }, () => {
                        var userId = this.user.username === undefined ? '' : this.user.username;
                        this.props.dispatch({ type: "action_get_general_strategy_result_search", payload: { t: type, u: userId, i: record.key } });
                    });
                }
            }
        }
    }

    setRowClassName = (record) => {
        return record.key.toString() === this.state.rowId.toString() ? 'common-table-row' : '';
    }

    render() {
        var { dataSource } = this.state;

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'center',
                width: 50
            },
            {
                title: languageMessages['tradingStraregy'],
                dataIndex: 'tradingStraregy',
                width: 100
            }, {
                title: languageMessages['minimumCapital'],
                dataIndex: 'capital',
                width: 155,
                align: 'center',
                sorter: (a, b) => a.capital - b.capital,
                sortDirections: ['descend', 'ascend'],
            }
        ];

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['mySimulated'] + ' » ' + languageMessages['generalStrategy']}</h1>)} />
                </div>
                <div style={{ padding: '0px 50px' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['strategy.items']}</div>

                    <Table bordered size='small' locale={{ emptyText: ' ' }}
                        columns={columns}
                        dataSource={dataSource}
                        onRow={this.OnSelectShowChart}
                        rowClassName={this.setRowClassName} pagination={false} />

                    <div style={{ padding: '20px 0', fontWeight: 'bold' }}>{languageMessages['tradingStraregy'] + ': ' + this.state.strategyName}</div>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {this.state.statisticsResult.length == 0 || (<TradeResult dispatch={this.props.dispatch} statisticsResult={this.state.statisticsResult} type={this.state.type} />)}
                </Content>
            </Spin>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.trade;
}

const page = connect(mapStateToProps)(RealTimeGeneralStrategyPage);
export { page as default }